function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/observer/selectionobserver
 */

/* global setInterval, clearInterval */
import Observer from './observer';
import MutationObserver from './mutationobserver';
import { debounce } from 'lodash-es';
/**
 * Selection observer class observes selection changes in the document. If a selection changes on the document this
 * observer checks if there are any mutations and if the DOM selection is different from the
 * {@link module:engine/view/document~Document#selection view selection}. The selection observer fires
 * {@link module:engine/view/document~Document#event:selectionChange} event only if a selection change was the only change in the document
 * and the DOM selection is different then the view selection.
 *
 * Note that this observer is attached by the {@link module:engine/view/view~View} and is available by default.
 *
 * @see module:engine/view/observer/mutationobserver~MutationObserver
 * @extends module:engine/view/observer/observer~Observer
 */

var SelectionObserver = /*#__PURE__*/function (_Observer) {
  _inherits(SelectionObserver, _Observer);

  var _super = _createSuper(SelectionObserver);

  function SelectionObserver(view) {
    var _this;

    _classCallCheck(this, SelectionObserver);

    _this = _super.call(this, view);
    /**
     * Instance of the mutation observer. Selection observer calls
     * {@link module:engine/view/observer/mutationobserver~MutationObserver#flush} to ensure that the mutations will be handled
     * before the {@link module:engine/view/document~Document#event:selectionChange} event is fired.
     *
     * @readonly
     * @member {module:engine/view/observer/mutationobserver~MutationObserver}
     * module:engine/view/observer/selectionobserver~SelectionObserver#mutationObserver
     */

    _this.mutationObserver = view.getObserver(MutationObserver);
    /**
     * Reference to the view {@link module:engine/view/documentselection~DocumentSelection} object used to compare
     * new selection with it.
     *
     * @readonly
     * @member {module:engine/view/documentselection~DocumentSelection}
     * module:engine/view/observer/selectionobserver~SelectionObserver#selection
     */

    _this.selection = _this.document.selection;
    /* eslint-disable max-len */

    /**
     * Reference to the {@link module:engine/view/view~View#domConverter}.
     *
     * @readonly
     * @member {module:engine/view/domconverter~DomConverter} module:engine/view/observer/selectionobserver~SelectionObserver#domConverter
     */

    /* eslint-enable max-len */

    _this.domConverter = view.domConverter;
    /**
     * A set of documents which have added `selectionchange` listener to avoid adding a listener twice to the same
     * document.
     *
     * @private
     * @member {WeakSet.<Document>} module:engine/view/observer/selectionobserver~SelectionObserver#_documents
     */

    _this._documents = new WeakSet();
    /**
     * Fires debounced event `selectionChangeDone`. It uses `lodash#debounce` method to delay function call.
     *
     * @private
     * @param {Object} data Selection change data.
     * @method #_fireSelectionChangeDoneDebounced
     */

    _this._fireSelectionChangeDoneDebounced = debounce(function (data) {
      return _this.document.fire('selectionChangeDone', data);
    }, 200);
    _this._clearInfiniteLoopInterval = setInterval(function () {
      return _this._clearInfiniteLoop();
    }, 1000);
    /**
     * Private property to check if the code does not enter infinite loop.
     *
     * @private
     * @member {Number} module:engine/view/observer/selectionobserver~SelectionObserver#_loopbackCounter
     */

    _this._loopbackCounter = 0;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelectionObserver, [{
    key: "observe",
    value: function observe(domElement) {
      var _this2 = this;

      var domDocument = domElement.ownerDocument; // Add listener once per each document.

      if (this._documents.has(domDocument)) {
        return;
      }

      this.listenTo(domDocument, 'selectionchange', function (evt, domEvent) {
        _this2._handleSelectionChange(domEvent, domDocument);
      });

      this._documents.add(domDocument);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(SelectionObserver.prototype), "destroy", this).call(this);

      clearInterval(this._clearInfiniteLoopInterval);

      this._fireSelectionChangeDoneDebounced.cancel();
    }
    /**
     * Selection change listener. {@link module:engine/view/observer/mutationobserver~MutationObserver#flush Flush} mutations, check if
     * a selection changes and fires {@link module:engine/view/document~Document#event:selectionChange} event on every change
     * and {@link module:engine/view/document~Document#event:selectionChangeDone} when a selection stop changing.
     *
     * @private
     * @param {Event} domEvent DOM event.
     * @param {Document} domDocument DOM document.
     */

  }, {
    key: "_handleSelectionChange",
    value: function _handleSelectionChange(domEvent, domDocument) {
      if (!this.isEnabled) {
        return;
      }

      var domSelection = domDocument.defaultView.getSelection();

      if (this.checkShouldIgnoreEventFromTarget(domSelection.anchorNode)) {
        return;
      } // Ensure the mutation event will be before selection event on all browsers.


      this.mutationObserver.flush(); // If there were mutations then the view will be re-rendered by the mutation observer and the selection
      // will be updated, so the selections will equal and the event will not be fired, as expected.

      var newViewSelection = this.domConverter.domSelectionToView(domSelection); // Do not convert selection change if the new view selection has no ranges in it.
      //
      // It means that the DOM selection is in some way incorrect. Ranges that were in the DOM selection could not be
      // converted to the view. This happens when the DOM selection was moved outside of the editable element.

      if (newViewSelection.rangeCount == 0) {
        this.view.hasDomSelection = false;
        return;
      }

      this.view.hasDomSelection = true;

      if (this.selection.isEqual(newViewSelection) && this.domConverter.isDomSelectionCorrect(domSelection)) {
        return;
      } // Ensure we are not in the infinite loop (#400).
      // This counter is reset each second. 60 selection changes in 1 second is enough high number
      // to be very difficult (impossible) to achieve using just keyboard keys (during normal editor use).


      if (++this._loopbackCounter > 60) {
        // Selection change observer detected an infinite rendering loop.
        // Most probably you try to put the selection in the position which is not allowed
        // by the browser and browser fixes it automatically what causes `selectionchange` event on
        // which a loopback through a model tries to re-render the wrong selection and again.
        //
        // @if CK_DEBUG // console.warn( 'Selection change observer detected an infinite rendering loop.' );
        return;
      }

      if (this.selection.isSimilar(newViewSelection)) {
        // If selection was equal and we are at this point of algorithm, it means that it was incorrect.
        // Just re-render it, no need to fire any events, etc.
        this.view.forceRender();
      } else {
        var data = {
          oldSelection: this.selection,
          newSelection: newViewSelection,
          domSelection: domSelection
        }; // Prepare data for new selection and fire appropriate events.

        this.document.fire('selectionChange', data); // Call `#_fireSelectionChangeDoneDebounced` every time when `selectionChange` event is fired.
        // This function is debounced what means that `selectionChangeDone` event will be fired only when
        // defined int the function time will elapse since the last time the function was called.
        // So `selectionChangeDone` will be fired when selection will stop changing.

        this._fireSelectionChangeDoneDebounced(data);
      }
    }
    /**
     * Clears `SelectionObserver` internal properties connected with preventing infinite loop.
     *
     * @protected
     */

  }, {
    key: "_clearInfiniteLoop",
    value: function _clearInfiniteLoop() {
      this._loopbackCounter = 0;
    }
  }]);

  return SelectionObserver;
}(Observer);
/**
 * Fired when a selection has changed. This event is fired only when the selection change was the only change that happened
 * in the document, and the old selection is different then the new selection.
 *
 * Introduced by {@link module:engine/view/observer/selectionobserver~SelectionObserver}.
 *
 * Note that because {@link module:engine/view/observer/selectionobserver~SelectionObserver} is attached by the
 * {@link module:engine/view/view~View} this event is available by default.
 *
 * @see module:engine/view/observer/selectionobserver~SelectionObserver
 * @event module:engine/view/document~Document#event:selectionChange
 * @param {Object} data
 * @param {module:engine/view/documentselection~DocumentSelection} data.oldSelection Old View selection which is
 * {@link module:engine/view/document~Document#selection}.
 * @param {module:engine/view/selection~Selection} data.newSelection New View selection which is converted DOM selection.
 * @param {Selection} data.domSelection Native DOM selection.
 */

/**
 * Fired when selection stops changing.
 *
 * Introduced by {@link module:engine/view/observer/selectionobserver~SelectionObserver}.
 *
 * Note that because {@link module:engine/view/observer/selectionobserver~SelectionObserver} is attached by the
 * {@link module:engine/view/view~View} this event is available by default.
 *
 * @see module:engine/view/observer/selectionobserver~SelectionObserver
 * @event module:engine/view/document~Document#event:selectionChangeDone
 * @param {Object} data
 * @param {module:engine/view/documentselection~DocumentSelection} data.oldSelection Old View selection which is
 * {@link module:engine/view/document~Document#selection}.
 * @param {module:engine/view/selection~Selection} data.newSelection New View selection which is converted DOM selection.
 * @param {Selection} data.domSelection Native DOM selection.
 */


export { SelectionObserver as default };